let config = {

	development: {
		backendUrl: 'http://localhost:3001'
	},

	heroku: {
		backendUrl: 'https://gemuu-backend.herokuapp.com'
	}

};

export default config;



// WEBPACK FOOTER //
// ./src/config.js